module.exports = __webpack_public_path__ + "img/ShoppingCart.09a66cc7.svg";